import { useState } from 'react';
import useAwaitImageCreation from '../hooks/useAwaitImageCreation';
import {
  useServiceAuth,
  useActiveProjectId,
  useNotify,
} from '../../../../hooks';
import { useIntl, defineMessages } from 'react-intl';
import SurveyService from '../../../../services/SurveyService';
import { useCustomCompareEffect } from 'react-use';

const messages = defineMessages({
  getDownloadUrlError: {
    id: 'SurveyImage.getDownloadUrlError',
    defaultMessage: 'Error occurred loading image',
  },
});

const surveyService = new SurveyService();

function useImageDownloadUrl(imageId: string, surveyId: string) {
  // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
  const [downloadUrl, setDownloadUrl] = useState<string>(null);
  const projectId = useActiveProjectId();
  const serviceAuth = useServiceAuth();
  const [notify] = useNotify();
  const { formatMessage } = useIntl();
  const { awaitCreation } = useAwaitImageCreation();

  useCustomCompareEffect(
    () => {
      // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
      setDownloadUrl(null);
      async function load() {
        await awaitCreation(imageId);
        const response = await surveyService.getSurveyImage(serviceAuth)(
          projectId,
          surveyId,
          imageId,
        );

        return response.data.downloadUrl;
      }

      load()
        .then(setDownloadUrl)
        .catch(e => {
          console.error(e);
          notify(formatMessage(messages.getDownloadUrlError), 'error');
        });
    },
    [
      imageId,
      awaitCreation,
      formatMessage,
      notify,
      projectId,
      serviceAuth,
      surveyId,
    ],
    ([prevImageId], [nextImageId]) => prevImageId === nextImageId,
  );

  return downloadUrl;
}

export default useImageDownloadUrl;
